<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">用户数据授权协议</div>
    <div class="main_item">
      <h2>一、&nbsp;定义</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            神州邦邦平台：指运营主体为北京神州邦邦技术服务有限公司及其关联公司，为用户提供服务交易的网络平台，平台网址
            <a href="www.shenzhoubb.com">www.shenzhoubb.com</a> 。
          </p>
        </li>
        <li>
          <p>
            用户：是指具有相应的民事行为能力，在神州邦邦平台自主完成全部注册程序的自然人、法人或其他组织（“您”）。
          </p>
        </li>
        <li>
          <p>雇主：是指在神州邦邦平台注册且通过该平台发布服务需求的用户。</p>
        </li>
        <li>
          <p>
            工程师：是指在神州邦邦平台注册且通过该平台向雇主提供服务的用户。
          </p>
        </li>
        <li>
          <p>
            用户数据：是指您在实际经营活动中上传至、产生于或留存在神州邦邦平台的相关数据信息，包括：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>用户基础信息，包括用户头像、用户名称、接单偏好等相关信息。</p>
            </li>
            <li>
              <p>
                经营数据信息，包括在平台发布的服务/案例、交易相关的订单金额/评价/评分等信息。
              </p>
            </li>
            <li>
              <p>企业信息，包括企业名称、组织机构代码等相关信息。</p>
            </li>
            <li>
              <p>法定代表人个人信息，包括法定代表人的姓名、年龄等相关信息。</p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>二、&nbsp;授权使用</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            授权人：如您为企业法人，则您公司员工的授权行为，视为您的授权。如您为不满十四周岁的未成年人，应当取得父母或者其他监护人的同意进行授权。
          </p>
        </li>
        <li>
          <p>被授权人：神州邦邦平台。</p>
        </li>
        <li>
          <p>授权内容：</p>
          <p>
            如您点击同意本协议后，您将免费授权神州邦邦将您授权范围内的数据、信息进行如下方式的使用：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                由神州邦邦定期或不定期将您的数据部分或全部进行后台分析以及创建数据分析模型；
              </p>
            </li>
            <li>
              <p>
                当您通过神州邦邦平台申请注册之时或之后，由神州邦邦将您的数据部分或全部以及神州邦邦对您提供的数据的分析结果提供至相关神州邦邦平台。该数据和分析结果将为神州邦邦平台参考和使用，以便于其作出是否为您提供相关服务的决策以及持续为您提供相关服务。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>授权期限：</p>
          <p>您同意：在神州邦邦平台为您提供服务的期间。</p>
        </li>
        <li>
          <p>授权范围：</p>
          <p>
            您同意授神州邦邦所使用和获取的数据范围为：（1）用户基础信息；（2）经营数据查信息；（3）企业信息；（4）法定代表人个人信息等；
          </p>
        </li>
        <li>
          <p>
            在前述目的及本协议约定的范围限制下，您授权神州邦邦平台自行决定输出数据的时间、范围、方式、对象等，并无需预先通知您。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>三、&nbsp;数据保密</h2>
      <ul class="content_wrap1">
        <li>
          <p>神州邦邦平台有相应的安全措施来确保相应数据不丢失、不被滥用。</p>
        </li>
        <li>
          <p>
            您需保管好相关信息，因您个人原因，包括但不限于密码泄露等，将数据信息泄露于其他第三方，所导致的一切法律后果，由您自行承担。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>四、&nbsp;声明与承诺</h2>
      <ul class="content_wrap1">
        <li>
          <p>您承诺具有阅读并同意本协议或作出上述授权的主体资格。</p>
        </li>
        <li>
          <p>
            您保证您的数据真实、合法、有效，不存在侵犯任何第三方的商业秘密、知识产权、隐私权等合法权利的行为。
          </p>
        </li>
        <li>
          <p>
            您已经了解并知悉您的数据的重要性，且您仍愿意授权神州邦邦在符合本协议目的之下使用您的数据。
          </p>
        </li>
        <li>
          <p>
            对于您上传数据中的个人信息，您应确保已经事先获得相关个人信息主体对于收集、使用、共享、处理其个人信息的明确同意，并已充分告知上述个人信息主体有关个人信息收集、使用、处理的目的、范围及方式等。
          </p>
        </li>
        <li>
          <p>
            不滥用数据：神州邦邦平台承诺所接触的数据将仅为完成本协议所说明的目的而使用，不将数据用于其他任何场合，也不以任何其他方式滥用数据。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>五、&nbsp;协议更新及您的注意义务</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            更新：根据国家法律法规变化及神州邦邦平台运营需要，神州邦邦平台有权对本协议条款进行修改，并在规则中心进行公示，变更内容将在公示期满生效。
          </p>
        </li>
        <li>
          <p>
            注意义务：您有义务不时关注并阅读最新版的协议、其他条款及平台公告。如您不同意更新后的协议，可以且应立即停止接受神州邦邦平台依据本协议提供的服务；如您继续使用神州邦邦平台提供的服务的，即视为同意更新后的协议。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>六、&nbsp;法律管辖和适用</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            本协议及与本协议有关的一切争议、解释等，均适用中华人民共和国法律（不含港澳台地区法律）。
          </p>
        </li>
        <li>
          <p>
            本协议发生争议时，应友好协商解决；如果协商不成，双方一致同意提交北京仲裁委员会按照其仲裁规则进行裁决。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>七、&nbsp;其他</h2>
      <ul class="content_wrap1">
        <li>
          <p>
            神州邦邦平台尊重您的合法权利，本协议及平台上发布的各类规则、声明、售后服务政策等其他内容，均是为了更好的、更加便利的为您提供服务。神州邦邦欢迎您提出意见和建议，将虚心接受并适时修改本协议及平台上的各类规则。
          </p>
        </li>
        <li>
          <p>
            您点击“同意”即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>